"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var drive_types_1 = require("../../../common/types/drive.types");
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var time_2 = require("../../../common/helpers/time");
var StudentUpcomingDrivesController = /** @class */ (function () {
    function StudentUpcomingDrivesController(UsersModel, UserService) {
        this.UsersModel = UsersModel;
        this.date = new Date();
        this.student = UserService.getCurrentUser();
        this.classes = [];
        this.loading = true;
        this.currentPage = 1;
        this.options = {
            id: this.student.id,
            drivesAfter: (0, time_1.toYMD)(new Date()),
            order: "asc",
            page: 1,
            page_results: true,
        };
        this.pageChanged = this.pageChanged.bind(this);
        this.formatDrive = this.formatDrive.bind(this);
        this.handleUpcomingStudentDrives =
            this.handleUpcomingStudentDrives.bind(this);
        UsersModel.getStudentDrives(this.options).then(this.handleUpcomingStudentDrives);
    }
    StudentUpcomingDrivesController.prototype.handleUpcomingStudentDrives = function (response) {
        // this.totalItems = response.drives.total;
        this.drives = response.drives.map(this.formatDrive);
        this.loading = false;
    };
    StudentUpcomingDrivesController.prototype.formatDrive = function (drive) {
        Object.assign(drive, (0, drive_types_1.formatDriveForDisplay)(drive));
        if (drive.observation === true) {
            drive.type.name = drive.type.name + " (Observation)";
            // Each observation comes through the student's own pivot, so show their
            // slot when present; otherwise the envelope from above stays.
            if (drive.pivot && drive.pivot.start && drive.pivot.end) {
                var window_1 = (0, observation_windows_1.parsePivotWindow)(drive.pivot.start, drive.pivot.end);
                drive.startTime = (0, time_2.formatDateTime)(window_1.start, "h:mm A");
                drive.endTime = (0, time_2.formatDateTime)(window_1.end, "h:mm A");
            }
        }
        return drive;
    };
    StudentUpcomingDrivesController.prototype.pageChanged = function () {
        this.options.page = this.currentPage;
        this.UsersModel.getStudentDrives(this.options).then(this.handleUpcomingStudentDrives);
    };
    return StudentUpcomingDrivesController;
}());
StudentUpcomingDrivesController.$inject = ["UsersModel", "UserService"];
exports.default = StudentUpcomingDrivesController;
